import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  FormHelperText,
  useTheme,
} from '@mui/material';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../../styles/RichTextField.scss';

const RichTextField = ({
  label = '',
  value,
  onChange,
  placeholder = '',
  error = false,
  helperText = '',
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={error}
      sx={{ 
        ...sx }}
    >
      <InputLabel
        shrink
        sx={{
          backgroundColor: theme.palette.background.outlined,
          px: 0.5,
          mx: 1,
          color: theme.palette.text.outlined,
          // transform: 'translate(2px, -9px) scale(0.75)',
          '&.Mui-focused': {
            color: theme.palette.text.outlined,
          },
        }}
      >
        {label}
      </InputLabel>

      <Box
        sx={{
          border: `1px solid rgb(186, 184, 184)`,
          borderRadius: '8px',
          padding: '10px',
          minHeight: '180px',
          '&:hover': {
            borderColor: theme.palette.text.border,
          },
          '&:focus-within': {
            borderColor: theme.palette.text.border,
            boxShadow: `0 0 0 1px ${theme.palette.text.border}`,
          },
        }}
      >
        <Editor
          editorState={value}
          onEditorStateChange={onChange}
          editorStyle={{
            padding: '15px',
            minHeight: '140px',
            maxHeight: '300px',
            overflowY: 'auto',
            outline: 'none',
            color: theme.palette.text.primary,
            fontSize: '14px',
            lineHeight: '1.4',
          }}
          placeholder={placeholder}
          toolbar={{
            options: ['inline', 'list', 'textAlign', 'history'],
            inline: { options: ['bold', 'italic', 'underline'] },
            list: { options: ['unordered', 'ordered'] },
          }}
        />
      </Box>

      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default RichTextField;
